module.exports = __webpack_public_path__ + "img/download-close.cbb30e61.svg";